import type React from "react";

interface DropdownIconProps {
  className?: string;
}

export const DropdownIcon: React.FC<DropdownIconProps> = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="9"
    height="5"
    viewBox="0 0 9 5"
    fill="none"
  >
    <path
      d="M4.47088 3.69617L7.93434 0.179426C8.05215 0.0598091 8.18959 0.00199399 8.34666 0.0059813C8.50373 0.00996814 8.64117 0.0717705 8.75898 0.191388C8.87678 0.311005 8.93569 0.450558 8.93569 0.610048C8.93569 0.769537 8.87678 0.909091 8.75898 1.02871L5.14237 4.71292C5.04813 4.80861 4.9421 4.88038 4.8243 4.92823C4.70649 4.97608 4.58869 5 4.47088 5C4.35308 5 4.23527 4.97608 4.11747 4.92823C3.99966 4.88038 3.89364 4.80861 3.7994 4.71292L0.171007 1.02871C0.0532022 0.909091 -0.00373677 0.767544 0.00019006 0.604067C0.00411689 0.44059 0.0649827 0.299043 0.182788 0.179426C0.300592 0.0598092 0.438031 4.69451e-07 0.595104 4.66803e-07C0.752177 4.64154e-07 0.889616 0.0598092 1.00742 0.179426L4.47088 3.69617Z"
      fill="currentColor"
    />
  </svg>
);
